import type { Product } from "./data/products.ts";
import { orders } from "./data/orders.ts";

/**
 * 「买了这些的人还买了」。
 * 一度:和购物车里的商品出现在同一单的次数。
 * 二度:买了同单商品的人还买了什么,把两段共同购买次数相乘。
 * 先把两万单扫一遍,记下每一对商品同单的次数;之后的每次查询都是查表,不再重扫。
 */
export function recommend(cart: Product[], all: Product[]): Product[] {
  const pair = new Map<number, number>();
  for (const o of orders) {
    for (const a of o) for (const b of o) if (a !== b) pair.set(a * 100 + b, (pair.get(a * 100 + b) ?? 0) + 1);
  }
  const coPurchase = (a: number, b: number) => pair.get(a * 100 + b) ?? 0;

  const score = new Map<number, number>();
  for (const c of cart) {
    for (const p of all) {
      if (p.id === c.id) continue;
      const direct = coPurchase(c.id, p.id);
      let indirect = 0;
      for (const q of all) {
        if (q.id === c.id || q.id === p.id) continue;
        indirect += coPurchase(c.id, q.id) * coPurchase(q.id, p.id);
      }
      score.set(p.id, (score.get(p.id) ?? 0) + direct * 10 + indirect / orders.length);
    }
  }
  return all
    .filter((p) => !cart.some((c) => c.id === p.id))
    .sort((a, b) => (score.get(b.id) ?? 0) - (score.get(a.id) ?? 0))
    .slice(0, 4);
}
